import { UpdateProfileViewModel } from './update-profile-view-model.type';
import { DisplayAccountViewModel } from './display-account-view-model.type';
import { MonitorKey } from '../../monitor-models/monitor-key.type';

export class UpdateAccountViewModel extends UpdateProfileViewModel {
  Roles: string[];
  AvailableScreenKeys: MonitorKey[];
  AvailableMachines: string[];
  AvailableCategories: number[];
  IsMainDashboardAllowed: boolean;
  SharedPlaylistsIds: number[] = [];
  SharedMonitorTagsIds: number[] = [];
  NewPassword: string;
  ConfirmPassword: string;

  constructor(user: Partial<DisplayAccountViewModel> = {}) {
    super();
    Object.assign(this, user);
  }
}
